import {Router} from "@/rawdogjs/src/router";
import {BehaviorSubject} from "rxjs";
import {DependencyContainerFactory} from "@/rawdogjs/src/dependencyContainerFactory";
import {UserStore} from "./UserStore";
import {TenantProfileStore} from "./TenantProfileStore";
import {BookingApi} from "../../services/api/base/BookingApi";

export class BookingStore {

    private static instance: BookingStore;
    private _router: Router;


    constructor(router: Router) {
        this._router = router;
    }

    public static getInstance(router: Router): BookingStore {

        if (!BookingStore.instance) {
            BookingStore.instance = new BookingStore(router);
        }

        return BookingStore.instance;
    }

    private bookingSubject = new BehaviorSubject<any>(null);
    public booking$ = this.bookingSubject.asObservable();

    public setBooking(booking: any) {

        // const target = new BookingStoreDefinition();
        // target.bookingDate = booking.bookingDate ? new Date(booking.bookingDate) : null; 
        // const typed = { ...booking, ...target};

        this.bookingSubject.next(booking);
    }

    public getBooking() {
        return this.bookingSubject.value;
    }

    public async pull(callback: Function | null = null) {
        const dependencyContainer = DependencyContainerFactory.create(this._router);
        const tenantStore = dependencyContainer.resolve<UserStore>('UserStore');
        const tenantProfileStore = dependencyContainer.resolve<TenantProfileStore>('TenantProfileStore');
        const bookingApi = dependencyContainer.resolve<BookingApi>('BookingApi');

        // cannot initialize if we don't have user info 
        if(!tenantStore.getParentTenant())
            return;       

        const result = await bookingApi.get(
            null,
            tenantStore.getParentTenant(),
            {
                id: tenantProfileStore.getTenantProfile().currentWorkingBookingId
            },
            true,
            false,
            true
        );

        this.setBooking(result.data);
        
        if(callback)
            callback(result.data);
        
    }


    public async fetch(bookingApi: BookingApi, bookingId: string, parentTenantId: string) {
        const result = await bookingApi.get(
            null,
            parentTenantId,
            {
                id: bookingId
            },
            true,
            false,
            true
        );

        this.setBooking(result.data);
        return this.getBooking();
    }


}